import React, { ReactNode } from 'react';
import classNames from 'classnames';
import * as styles from './ModalFooter.module.scss';

type ModalFooterProps = {
  children: ReactNode;
  className?: string;
};

export const ModalFooter = ({ children, className }: ModalFooterProps) => {
  return (
    <footer className={classNames(className, styles.ModalFooter)}>
      {children}
    </footer>
  );
};
